import React from 'react';
import dynamic from 'next/dynamic';
import { MemberOnlyOrganizationWrapper } from 'screens/organizations/context/EditOrganizationProvider';

const OrganizationChat = dynamic(() => import('features/organizations/chat'), {
  ssr: false
});

const OrganizationChatScreen = () => <OrganizationChat />;

export default OrganizationChatScreen;

OrganizationChatScreen.getLayout = (page) => (
  <MemberOnlyOrganizationWrapper>{page}</MemberOnlyOrganizationWrapper>
);
